/* eslint-disable */
// AUTO-GENERATED by scripts/compileLocales.ts - DO NOT EDIT
// Reverse mapping: message value -> message id for locale "en"

export const reverse: Record<string, string> = {
  "Enter the 6-digit code sent to your email.": "enter_pin_message",
  "Enter the 6-digit code sent to your phone.": "enter_pin_message_phone",
  "You're offline. Please reconnect to the internet and try again.": "validateMsg.apiError.offline",
  "Please enter firmware version.": "validateMsg.firmware.version",
  "The version you entered already exists.": "validateMsg.firmware.duplicateVersion",
  "Please upload firmware file.": "validateMsg.firmware.file",
  "Please enter release note.": "validateMsg.firmware.releaseNote",
  "Payload validation error": "validateMsg.signup.30001",
  "Invalid token": "validateMsg.signup.30002",
  "Insufficient scope": "validateMsg.signup.30003",
  "Rate limit exceeded": "validateMsg.signup.30004",
  "An internal error occurred": "validateMsg.signup.30005",
  "Password has previously been used": "validateMsg.signup.30006",
  "User not found": "validateMsg.signup.30007",
  "There was an error processing the password reset.": "validateMsg.signup.30100",
  "Please enter a valid company name.": "validateMsg.signup.orgName",
  "This email has already been sent with an invitation.\nPlease check your mailbox again or contact your organization's administrator if you would like to receive the invitation email again.": "validateMsg.signup.reseller.1024",
  "Reseller submission failed.": "validateMsg.signup.resellerSubmissionFail",
  "Reseller signup failed.": "validateMsg.signup.resellerSignupFail",
  "Company name cannot be blank.": "validateMsg.signup.companyName",
  "An error occurred. Please try again later.": "validateMsg.signup.defaultError",
  "Organization does not exist.": "validateMsg.signup.accountNotFound",
  "Incorrect login credentials.": "validateMsg.signup.loginIncorrect",
  "Please enter your first name.": "validateMsg.signup.firstname",
  "Please enter your last name.": "validateMsg.signup.lastname",
  "The password you entered does not match.": "validateMsg.signup.passwordMismatch",
  "Password cannot be blank.": "validateMsg.signup.password.empty",
  "Password must be at least 8 characters.": "validateMsg.signup.password.short",
  "Password must contain both lowercase and uppercase letters.": "validateMsg.signup.password.NotContainUppercase",
  "Password must contain one or more numeric and special characters.": "validateMsg.signup.password.NotContainSpecial",
  "Please accept the signup invite sent to this address": "validateMsg.signup.disActivateUser",
  "Your new password doesn’t meet the required criteria.": "validateMsg.signup.reSetPassword.notRequired",
  "The phone number you entered is in an invalid format.": "validateMsg.signup.phone.invalidFormat",
  "You must enter a phone number when use 2FA code.": "validateMsg.signup.phone.cantBe2fa",
  "Phone number is required.": "validateMsg.signup.phone.empty",
  "Please review the user agreement.": "validateMsg.signup.agreement",
  "The code you entered does not match.": "validateMsg.signup.verifyNumber",
  "Please verify your phone number.": "validateMsg.signup.requiredVerifyNumber",
  "Sign-up failed during the registration process.": "validateMsg.signup.fail",
  "Please contact your administrator.": "validateMsg.signup.getTokenEmail",
  "Invitation has expired. Please contact your administrator.": "validateMsg.signup.getTokenExpire",
  "Invitation is invalid. Please contact your administrator.": "validateMsg.signup.getTokenInvalid",
  "Please enter the verification code.": "validateMsg.signup.requiredVerifyCode",
  "Sending of the verification message failed.": "validateMsg.signup.invalidPhoneNumber",
  "User information was not found.": "validateMsg.signup.noUserInformation",
  "Invalid email address": "validateMsg.signup.invalidEmail",
  "Phone number entered not found in the system.": "validateMsg.signup.noExistPhone",
  "Email does not exist": "validateMsg.signup.noExistEmail",
  "Invitation email does not match authenticated email.": "validateMsg.signup.email.difference",
  "Use the DW Spectrum Web Login button to log in to myDW": "validateMsg.signup.checkEmail.cloudUser",
  "The email address entered is not registered": "validateMsg.signup.checkEmail.noExist",
  "Password reset unsuccessful": "validateMsg.reset.fail",
  "The reset token has expired.\n Please retry again.": "validateMsg.reset.getTokenExpire",
  "The reset token is invalid. Please contact your administrator.": "validateMsg.reset.getTokenInvalid",
  "Address cannot be blank.": "validateMsg.profile.address.empty",
  "Please enter email.": "validateMsg.profile.email.empty",
  "Enter a valid email address.": "validateMsg.profile.email.irregular",
  "Please enter phone number.": "validateMsg.profile.phone.empty",
  "New phone number cannot be same as the one used previously.": "validateMsg.profile.phone.same",
  "Please try again with the correct format.": "validateMsg.profile.phone.validate",
  "The verification code has not been confirmed.": "validateMsg.profile.phone.verify.code",
  "Your phone number has not been verified.": "validateMsg.profile.phone.verify.fail",
  "Please enter current password.": "validateMsg.profile.passwordEmpty",
  "Please enter new password.": "validateMsg.profile.newPasswordEmpty",
  "Please do not exceed 255 characters.": "validateMsg.profile.description",
  "New password cannot be same as the one used previously.": "validateMsg.profile.passwordSame",
  "You entered an incorrect password": "validateMsg.login.password.incorrect",
  "Your DW Spectrum Cloud account is not linked to a myDW organization. Please accept the myDW invitation or contact your administrator.": "validateMsg.login.DWCloudUserNotRegistered",
  "Information update failed": "validateMsg.information.updateError",
  "Information updated successfully": "validateMsg.information.updateSuccess",
  "Please fill in all required fields": "validateMsg.information.requiredEmpty",
  "Please enter a valid value": "validateMsg.information.invalidValue",
  "The maximum number of items is 10": "validateMsg.information.maxLength",
  "Please enter a valid URL": "validateMsg.information.invalidURL",
  "Please enter a valid phone number": "validateMsg.information.invalidPhone",
  "Organization name cannot be blank.": "validateMsg.account.empty",
  "Your email is already part of this organization.": "validateMsg.account.userMail.same",
  "Email address is required.": "validateMsg.account.userMail.empty",
  "Failed to generate organization number": "validateMsg.account.generateId.fail",
  "Failed to delete organization.": "validateMsg.account.delete.fail",
  "Organization deleted successfully.": "validateMsg.account.delete.success",
  "Failed to add organization.": "validateMsg.account.create.fail",
  "Organization added successfully.": "validateMsg.account.create.success",
  "Failed to update organization.": "validateMsg.account.modify.fail",
  "Organization updated successfully.": "validateMsg.account.modify.success",
  "Please enter organization name.": "validateMsg.account.name",
  "Organization name must be 3-100 characters, include at least one alphabet character, and use only allowed characters.": "validateMsg.account.nameInvalid",
  "Organization level is mandatory.": "validateMsg.account.level",
  "If Custom is selected, a discount must be entered.": "validateMsg.account.discount.empty",
  "The organization needs permissions. Please contact your administrator.": "validateMsg.account.permissionsDeny",
  "The organization for transfer does not exist.": "validateMsg.account.transfer.3011",
  "You are not an administrator of the target organization.": "validateMsg.account.transfer.3012",
  "You are not an administrator of the destination organization.": "validateMsg.account.transfer.3013",
  "Transferring to another EU organization is not allowed.": "validateMsg.account.transfer.3014",
  "Transferring to another Sub CP organization is not allowed.": "validateMsg.account.transfer.3015",
  "Transferring to another DW organization is not allowed.": "validateMsg.account.transfer.3016",
  "Transfer is not allowed because Sub CPs exist under this organization.": "validateMsg.account.transfer.3017",
  "Transfers to the same organization are not allowed.": "validateMsg.account.transfer.3018",
  "The organization has been disabled.": "validateMsg.account.transfer.3019",
  "The organization has been suspended.": "validateMsg.account.transfer.3020",
  "Failed to transfer organization.": "validateMsg.account.transfer.fail",
  "Transferred organization successfully.": "validateMsg.account.transfer.success",
  "Failed to keep installer account.": "validateMsg.account.keepAccount.fail",
  "Keep installer account successfully.": "validateMsg.account.keepAccount.success",
  "Failed to remove installer account.": "validateMsg.account.removeAccount.fail",
  "Remove installer account successfully.": "validateMsg.account.removeAccount.success",
  "Failed to invite owner.": "validateMsg.account.invite.fail",
  "Invitation request sent successfully.": "validateMsg.account.invite.success",
  "You’ve reached the maximum of 8 favorite organizations.": "validateMsg.account.switch.max",
  "Success to request temporary access.": "validateMsg.account.access.temporary.success",
  "Failed to request temporary access.": "validateMsg.account.access.temporary.fail",
  "Please select a recipient admin user.": "validateMsg.account.access.temporary.validateMsg.recipient",
  "Please select a duration.": "validateMsg.account.access.temporary.validateMsg.duration",
  "Please enter user name.": "validateMsg.user.name",
  "Enter a valid email address": "validateMsg.user.email",
  "Please enter group name.": "validateMsg.user.group.name.empty",
  "Group name already exists.": "validateMsg.user.group.name.exist",
  "Failed to add group.": "validateMsg.user.group.fail",
  "A User Group must be selected.": "validateMsg.user.group.selected",
  "Please select one or more myDW Permissions.": "validateMsg.userGroup.userPermission",
  "Please select one or more recorders.": "validateMsg.userGroup.recorder",
  "Administrator, Manager, and Viewer group names are not allowed as they already exist.": "validateMsg.userGroup.sameDefault",
  "Select one or more users.": "validateMsg.userGroup.emptyAdmin",
  "Please enter the address of the recorder.": "validateMsg.recorder.emptyAddress",
  "Please enter recorder group name.": "validateMsg.recorderGroup.name",
  "Enter a message to send to the assigned technician": "validateMsg.alert.view.emptyAssignMessage",
  "Please select one or more organizations.": "validateMsg.alert.rule.emptyAccount",
  "Please enter alert rule name.": "validateMsg.alert.rule.emptyRuleName",
  "Please turn on one or more rules.": "validateMsg.alert.rule.emptyRule",
  "Please select one organization.": "validateMsg.report.rule.emptySingleAccount",
  "Please select one or more cameras.": "validateMsg.report.rule.emptyCamera",
  "Please enter report rule name.": "validateMsg.report.rule.emptyRuleName",
  "Please select one recorder.": "validateMsg.report.rule.emptySingleRecorder",
  "Please enter customer name.": "validateMsg.report.rule.emptyCustomName",
  "Please enter customer phone number.": "validateMsg.report.rule.emptyCustomPhone",
  "Please enter customer address.": "validateMsg.report.rule.emptyCustomAddress",
  "Please enter installer name.": "validateMsg.report.rule.emptyInstallName",
  "Please enter installer phone number.": "validateMsg.report.rule.emptyInstallPhone",
  "Please enter title.": "validateMsg.report.rule.emptyTitle",
  "Video Share upload successfully.": "validateMsg.videoShare.err.uploadSuccess",
  "Video Share upload failed.": "validateMsg.videoShare.err.uploadFail",
  "Select one or more users or enter email address.": "validateMsg.videoShare.err.emptyUser",
  "The entered email is invalid.": "validateMsg.videoShare.err.invalidEmail",
  "Video information is invalid.": "validateMsg.videoShare.err.invalidVideoId",
  "Please enter notice title.": "validateMsg.notice.title",
  "Please enter notice message.": "validateMsg.notice.message.empty",
  "Please do not exceed 500 characters.": "validateMsg.notice.message.exceed",
  "Please enter issue details.": "validateMsg.help.about.emptyIssue",
  "Issue reported successfully.": "validateMsg.help.about.success",
  "Failed to report issue.": "validateMsg.help.about.fail",
  "OTP generated successfully.": "validateMsg.help.utility.admin.generate.success",
  "Failed to generate OTP.": "validateMsg.help.utility.admin.generate.fail",
  "Please enter a MAC address.": "validateMsg.help.utility.admin.macAddress.empty",
  "Please enter a valid MAC address.": "validateMsg.help.utility.admin.macAddress.valid",
  "Please enter a time.": "validateMsg.help.utility.admin.time.empty",
  "Please enter a valid time.": "validateMsg.help.utility.admin.time.valid",
  "Please enter an email subject.": "validateMsg.setting.email.title.empty",
  "Please enter a message.": "validateMsg.setting.email.message.empty",
  "Please enter a send date / time.": "validateMsg.setting.email.scheduleTime.empty",
  "The URL you entered is in an invalid format.": "validateMsg.manager.video.url",
  "Please upload a file.": "validateMsg.manager.video.file",
  "Please click the thumbnail button to get a thumbnail.": "validateMsg.manager.video.thumbnail",
  "Release note added successfully.": "label.releaseNotes.add.success",
  "Failed to add release note.": "label.releaseNotes.add.fail",
  "Release note updated successfully.": "label.releaseNotes.update.success",
  "Failed to update release note.": "label.releaseNotes.update.fail",
  "Release note deleted successfully.": "label.releaseNotes.delete.success",
  "Failed to delete release note.": "label.releaseNotes.delete.fail",
  "Email reminder was sent successfully.": "label.login.forgotEmail.resend.sms",
  "Verification code sent successfully.": "label.signup.resendCode.success",
  "Failed to send verification code.": "label.signup.resendCode.fail",
  "Failed to update storage size.": "label.lyve.notify.update.fail",
  "Storage Size updated successfully.": "label.lyve.notify.update.success",
  "CPP must be three or more digits.": "label.lyve.generateKey.fail.70004",
  "CPP may not start with 0.": "label.lyve.generateKey.fail.70005",
  "CPP must only be digits.": "label.lyve.generateKey.fail.70006",
  "The CPP number is unavailable.": "label.lyve.generateKey.fail.70007",
  "Creating CPP is failed.": "label.lyve.generateKey.fail.70008",
  "Failed to generate key.": "label.lyve.generateKey.fail.default",
  "CPP Number must be greater than 100": "label.lyve.generateKey.cpp.fail",
  "CPP Number is required": "label.lyve.generateKey.cpp.required",
  "Part Number is required": "label.lyve.generateKey.partNumber.required",
  "Part Number is already in use": "label.lyve.generateKey.partNumber.same",
  "Failed to get features popup list": "label.features.list.fail",
  "Features popup deleted successfully": "label.features.notify.delete.success",
  "Failed to delete features popup": "label.features.notify.delete.fail",
  "Features popup added successfully": "label.features.notify.add.success",
  "Failed to add features popup": "label.features.notify.add.fail",
  "Features popup updated successfully": "label.features.notify.update.success",
  "Failed to update features popup": "label.features.notify.update.fail",
  "AWS communication failure.": "label.features.error.20001",
  "Files does not contain file_name.": "label.features.error.50006",
  "Announcement is not found.": "label.features.error.50007",
  "Announcement Slide Image is not found.": "label.features.error.50008",
  "Upload file is not image type.": "label.features.error.50009",
  "The Display Pop-up cannot be set to ON because the scheduled time has already passed.": "label.features.error.50010",
  "Email updated successfully.": "label.email.notify.update.success",
  "Email update failed.": "label.email.notify.update.fail",
  "Video added successfully.": "label.manager.video.create.success",
  "Failed to add video.": "label.manager.video.create.fail",
  "Video updated successfully.": "label.manager.video.modify.success",
  "Failed to update video.": "label.manager.video.modify.fail",
  "Video deleted successfully.": "label.manager.video.delete.success",
  "Failed to delete video.": "label.manager.video.delete.fail",
  "Video group added successfully.": "label.manager.video.group.create.success",
  "Failed to add video group.": "label.manager.video.group.create.fail",
  "Video group updated successfully.": "label.manager.video.group.modify.success",
  "Failed to update video group.": "label.manager.video.group.modify.fail",
  "Video group deleted successfully.": "label.manager.video.group.delete.success",
  "Failed to delete video group.": "label.manager.video.group.delete.fail",
  "File added successfully.": "label.manager.file.create.success",
  "Failed to add file.": "label.manager.file.create.fail",
  "Tech report updated successfully.": "label.manager.tech.modify.success",
  "Failed to modify tech report.": "label.manager.tech.modify.fail",
  "Organization is no longer available.": "label.org.notAvailable",
  "Apply to all current and future recorders.": "label.autoApply.recorder",
  "Add User Groups": "label.select.usersGroups",
  "Add Organizations": "label.select.account",
  "Add Recorders": "label.select.recorder",
  "Add Recorder Groups": "label.select.recorderGroup",
  "CVV": "label.select.verification",
  "Schedule": "label.select.schedule",
  "Click here for instructions to clear this alert.": "label.recorder.tooltip.alert.instruction",
  "Recorder assigned successfully.": "label.recorder.notify.transfer.success",
  "Failed to assign recorder. Please try again later.": "label.recorder.notify.transfer.fail",
  "Only PNG or JPG files can be uploaded.": "label.recorder.notify.thumbnail.type.error",
  "Failed to upload custom thumbnail.": "label.recorder.notify.thumbnail.upload.error",
  "Merged system updated successfully.": "label.recorder.notify.mergedSystem.update.success",
  "Failed to update merged system.": "label.recorder.notify.mergedSystem.update.fail",
  "Registered recorder not found.": "label.recorder.notify.search.error",
  "Recorder updated successfully.": "label.recorder.notify.update.success",
  "Failed to update recorder.": "label.recorder.notify.update.fail",
  "Recorder deleted successfully.": "label.recorder.notify.delete.success",
  "Failed to delete recorder.": "label.recorder.notify.delete.fail",
  "Failed to save connection information.": "label.recorder.notify.connection.fail",
  "The connection test was successful.": "label.recorder.notify.connectionTest.success",
  "The connection test failed.": "label.recorder.notify.connectionTest.fail",
  "System deleted successfully.": "label.recorder.notify.deRegistration.success",
  "Failed to delete system.": "label.recorder.notify.deRegistration.fail",
  "Recorder group added successfully.": "label.recorderGroup.notify.create.success",
  "Failed to add recorder group.": "label.recorderGroup.notify.create.fail",
  "Recorder group deleted successfully.": "label.recorderGroup.notify.delete.success",
  "Failed to delete recorder group.": "label.recorderGroup.notify.delete.fail",
  "Recorder group updated successfully.": "label.recorderGroup.notify.update.success",
  "Failed to update recorder group.": "label.recorderGroup.notify.update.fail",
  "Alert rule creation failed.": "label.alertRule.notify.create.fail",
  "Alert rule search error.": "label.alertRule.notify.getDetail.fail",
  "Alert rule added successfully.": "label.alertRule.notify.add.success",
  "Alert rule failed to be added.": "label.alertRule.notify.add.fail",
  "Alert rule updated successfully.": "label.alertRule.notify.update.success",
  "Alert rule update failed.": "label.alertRule.notify.update.fail",
  "Alert rule deleted successfully.": "label.alertRule.notify.delete.success",
  "Alert rule deletion failed.": "label.alertRule.notify.delete.fail",
  "Recorder is down or offline.": "label.alertRule.tooltip.recorderNotResponse",
  "Number of abnormal restarts in the last 24 hours.": "label.alertRule.tooltip.abnormal",
  "[VMAX Only] System temperature over 70": "label.alertRule.tooltip.systemOverheat",
  "[Only VMAX and COVA] Disk error or HDD S.M.A.R.T error detected.": "label.alertRule.tooltip.hardwareFailure",
  "[VMAX Only] Disk temperature over 70": "label.alertRule.tooltip.diskOverheat",
  "[VMAX Only] Percentage of bad sectors.": "label.alertRule.tooltip.badSector",
  "[Spectrum Only] One or more storage devices are being checked by media server.": "label.alertRule.tooltip.storageStatus",
  "[Spectrum Only] Recorder is reindexing of one or more storage devices.": "label.alertRule.tooltip.reIndex",
  "[Spectrum Only] Free space on the disk is below 20 GB.": "label.alertRule.tooltip.storageFull",
  "[Spectrum Only] Reserved space on the disk exceeds 110% of free space.": "label.alertRule.tooltip.reserveSpace",
  "Camera is offline or unauthorized.": "label.alertRule.tooltip.loss",
  "The Recording software may be malfunctioning": "label.alertRule.tooltip.notRecording",
  "Alert history search error.": "label.alertHistory.notify.search.fail",
  "Could not search recorder": "label.alertHistory.notify.subSystem.fail",
  "Failed to search report list.": "label.report.notify.list.search.fail",
  "CVV report deleted successfully.": "label.report.notify.cvv.delete.success",
  "Failed to delete CVV report.": "label.report.notify.cvv.delete.fail",
  "CVV report created successfully.": "label.report.notify.cvv.create.success",
  "Failed to create CVV report.": "label.report.notify.cvv.create.fail",
  "Failed to update the reference thumbnail.": "label.report.notify.cvv.update.90005",
  "CVV report updated successfully.": "label.report.notify.cvv.update.success",
  "Failed to update CVV report.": "label.report.notify.cvv.update.fail",
  "CVV search error.": "label.report.notify.cvv.list.error",
  "Camera reference updated successfully.": "label.report.notify.cvv.refer.camera.success",
  "No thumbnail available to update.": "label.report.notify.cvv.refer.camera.fail",
  "Recorder reference updated successfully.": "label.report.notify.cvv.refer.recorder.success",
  "Camera checked successfully.": "label.report.notify.cvv.checknow.success",
  "CP report deleted successfully.": "label.report.notify.cp.delete.success",
  "Failed to delete CP report.": "label.report.notify.cp.delete.fail",
  "CP report created successfully.": "label.report.notify.cp.create.success",
  "Failed to create CP report.": "label.report.notify.cp.create.fail",
  "CP report updated successfully.": "label.report.notify.cp.update.success",
  "Failed to update CP report.": "label.report.notify.cp.update.fail",
  "Health report deleted successfully.": "label.report.notify.health.delete.success",
  "Failed to delete Health report.": "label.report.notify.health.delete.fail",
  "Health report created successfully.": "label.report.notify.health.create.success",
  "Failed to create Health report.": "label.report.notify.health.create.fail",
  "Health report updated successfully.": "label.report.notify.health.update.success",
  "Failed to update Health report.": "label.report.notify.health.update.fail",
  "Health search error.": "label.report.notify.health.list.error",
  "Installation report deleted successfully.": "label.report.notify.install.delete.success",
  "Failed to delete Installation report.": "label.report.notify.install.delete.fail",
  "Installation report created successfully.": "label.report.notify.install.create.success",
  "Failed to create Installation report.": "label.report.notify.install.create.fail",
  "Installation report updated successfully.": "label.report.notify.install.update.success",
  "Failed to update Installation report.": "label.report.notify.install.update.fail",
  "Report marked as completed.": "label.report.notify.install.update.complete.success",
  "Failed to update the report as completed.": "label.report.notify.install.update.complete.fail",
  "The report email sent successfully.": "label.report.notify.install.emailSend.success",
  "Failed to send Installation report.": "label.report.notify.install.emailSend.fail",
  "Start thumbnail synchronization.": "label.report.notify.install.sync.success",
  "Failed to sync thumbnail.": "label.report.notify.install.sync.fail",
  "The thumbnail synchronization process completed successfully.": "label.report.notify.install.sync.end",
  "Failed to download configuration.": "label.report.notify.inventory.download.config.error",
  "Inventory report deleted successfully.": "label.report.notify.inventory.delete.success",
  "Failed to delete Inventory report.": "label.report.notify.inventory.delete.fail",
  "Inventory report created successfully.": "label.report.notify.inventory.create.success",
  "Failed to create Inventory report.": "label.report.notify.inventory.create.fail",
  "Inventory report updated successfully.": "label.report.notify.inventory.update.success",
  "Failed to update Inventory report.": "label.report.notify.inventory.update.fail",
  "Thumbnail report deleted successfully.": "label.report.notify.thumbnail.delete.success",
  "Failed to delete Thumbnail report.": "label.report.notify.thumbnail.delete.fail",
  "Thumbnail report created successfully.": "label.report.notify.thumbnail.create.success",
  "Failed to create Thumbnail report.": "label.report.notify.thumbnail.create.fail",
  "Thumbnail report updated successfully.": "label.report.notify.thumbnail.update.success",
  "Failed to update Thumbnail report.": "label.report.notify.thumbnail.update.fail",
  "Thumbnail search error.": "label.report.notify.thumbnail.list.error",
  "Click to select a user or enter an email address to send this report.": "label.report.send.email.placeholder",
  "Email sent successfully.": "label.common.notify.email.success",
  "Message sent successfully.": "label.common.notify.message.success",
  "Message sending failed.": "label.common.notify.message.fail",
  "User group added successfully.": "label.user.group.notify.add.success",
  "Failed to add User group.": "label.user.group.notify.add.fail",
  "User group updated successfully.": "label.user.group.notify.update.success",
  "Failed to update user group.": "label.user.group.notify.update.fail",
  "User group deleted successfully.": "label.user.group.notify.delete.success",
  "Failed to delete User group.": "label.user.group.notify.delete.fail",
  "Invite email sent successfully.": "label.user.notify.resend.success",
  "Failed to send invite email.": "label.user.notify.resend.fail",
  "User search error.": "label.user.notify.list.fail",
  "User removed successfully.": "label.user.notify.delete.success",
  "Failed to delete user.": "label.user.notify.delete.fail",
  "User added successfully.": "label.user.notify.add.success",
  "Failed to add user.": "label.user.notify.add.fail",
  "User updated successfully.": "label.user.notify.update.success",
  "Failed to update user.": "label.user.notify.update.fail",
  "User group search error.": "label.userGroup.notify.list.fail",
  "Failed to delete user group.": "label.userGroup.notify.delete.fail",
  "Failed to add user group.": "label.userGroup.notify.add.fail",
  "Video shared successfully.": "label.videoshare.notify.share.success",
  "Failed to share video.": "label.videoshare.notify.share.fail",
  "Video share updated successfully.": "label.videoshare.notify.share.update.success",
  "Failed to update video share.": "label.videoshare.notify.share.update.fail",
  "Comment added successfully.": "label.videoshare.notify.commentAdd.success",
  "Failed to add comment.": "label.videoshare.notify.commentAdd.fail",
  "Failed to delete comment.": "label.videoshare.notify.commentDel.fail",
  "Video share information updated successfully.": "label.videoshare.notify.save.success",
  "Failed to update video share information.": "label.videoshare.notify.save.fail",
  "Video share search error.": "label.videoshare.notify.search.error",
  "Video share deleted successfully.": "label.videoshare.notify.delete.success",
  "Failed to delete video share.": "label.videoshare.notify.delete.fail",
  "Your comment cannot exceed 250 characters.": "label.videoshare.notify.maxComment",
  "Shared information updated successfully.": "label.videoshare.notify.user.update.success",
  "Failed to update shared information.": "label.videoshare.notify.user.update.fail",
  "Shared user deleted successfully.": "label.videoshare.notify.user.delete.success",
  "Failed to delete Shared user.": "label.videoshare.notify.user.delete.fail",
  "For Security reasons, myDW required an email verification to access shared videos. Click the button below to send a verification code to": "label.videoshare.guest.verification.sendCode.desc",
  "The link you followed has expired.": "label.videoshare.guest.verification.sendCode.expired",
  "Success to resend code.": "label.videoshare.guest.verify.resend.success",
  "Failed to get Video Share.": "label.videoshare.guest.default.error",
  "Error while searching for alert": "label.alert.notify.list.error",
  "User assigned successfully.": "label.alert.notify.assigned.success",
  "Failed to assign user": "label.alert.notify.assign.fail",
  "Comment deleted successfully.": "label.alert.notify.commentDel.success",
  "Alert closed successfully.": "label.alert.notify.status.success",
  "Failed to close status.": "label.alert.notify.status.fail",
  "All statuses were successfully closed": "label.alert.notify.allClose.success",
  "Failed to close all statuses.": "label.alert.notify.allClose.fail",
  "The size of the image is larger than recommended": "label.profile.notify.image.over.error",
  "Failed to upload profile image.": "label.profile.notify.updateImage.fail",
  "Profile image deleted successfully.": "label.profile.notify.delImage.success",
  "Failed to delete profile image.": "label.profile.notify.delImage.fail",
  "Profile updated successfully.": "label.profile.notify.update.success",
  "Failed to update profile.": "label.profile.notify.update.fail",
  "Failed to deactivate profile.": "label.profile.notify.deactivate.fail",
  "User info not found.": "label.profile.notify.user.no",
  "User Profile Information not available.": "label.profile.notify.search.fail",
  "Theme not available.": "label.profile.notify.theme.fail",
  "Organization suspension updated successfully.": "label.billing.notify.update.success",
  "Failed to update organization suspension.": "label.billing.notify.update.fail",
  "Do you really want to suspend this organization?": "label.billing.notify.check.suspend.title",
  "Associated organization will also be suspended.": "label.billing.notify.check.suspend.subTitle",
  "Do you really want to reactivate this organization?": "label.billing.notify.check.reactivate.title",
  "Associated organization will also be reactivated.": "label.billing.notify.check.reactivate.subTitle",
  "Click to select a user or enter an email address to send subscription info to.": "label.subscription.send.email.placeholder",
  "Please enter all required information.": "label.subscription.generate.essential.validate",
  "Failed to subscribe. Please check your information.": "label.subscription.generate.checkout.fail",
  "Failed to generate keys.": "label.subscription.generate.keys.fail",
  "Please enter at least 1.": "label.subscription.key.essential.validate",
  "Please enter a key in the correct format. (1XXXX-XXXX-XXXX-XXXX)": "label.subscription.key.format.error",
  "Please select the type of the subscription keys.": "label.subscription.keyType.essential.validate",
  "Please select duration.": "label.subscription.duration.essential.validate",
  "Failed to checkout keys.": "label.subscription.checkout.fail",
  "Keys registered successfully.": "label.subscription.register.success",
  "Failed to register keys.": "label.subscription.register.fail",
  "Please enter at least one key.": "label.subscription.register.empty",
  "The uploaded file does not contain any keys.": "label.subscription.register.file.empty",
  "Enter a subscription key to activate.": "label.subscription.activate.key.empty",
  "Failed to activate subscription key.": "label.subscription.activate.fail",
  "Subscription key activated successfully.": "label.subscription.activate.success",
  "Failed to check subscription key.": "label.subscription.check.activate.fail",
  "Subscription key request sent succesfully.": "label.subscription.request.success",
  "Failed to request subscription key.": "label.subscription.request.fail",
  "Failed to get subscription key type.": "label.subscription.get.keyType.fail",
  "Failed to get subscription key price.": "label.subscription.get.keyPrice.fail",
  "Key confirmed successfully.": "label.subscription.confirm.success",
  "Failed to confirm key.": "label.subscription.confirm.fail",
  "Failed to get services & pricing.": "label.subscription.service.get.fail",
  "Failed to update services & pricing.": "label.subscription.service.update.fail",
  "Services & pricing updated successfully.": "label.subscription.service.update.success",
  "Key replaced successfully.": "label.subscription.replace.success",
  "Failed to replace key.": "label.subscription.replace.fail",
  "Failed to export keys.": "label.subscription.export.fail",
  "No key data to export.": "label.subscription.export.noData",
  "Failed to export detail info.": "label.subscription.export.summary.fail",
  "Failed to get detail info.": "label.subscription.detail.summary.fail",
  "Free key renewed successfully.": "label.subscription.cova.renew.success",
  "Failed to renew free key.": "label.subscription.cova.renew.fail",
  "Expiration date updated successfully.": "label.subscription.cova.reset.success",
  "Failed to update expiration date.": "label.subscription.cova.reset.fail",
  "Failed to get subscription organization list.": "label.subscription.org.list.fail",
  "Please enter a message": "label.subscription.sendEmail.empty",
  "Please enter a title": "label.subscription.sendEmail.title.empty",
  "Failed to find your connection information.": "label.link.notify.token.error",
  "Firmware added successfully.": "label.setting.firmware.notify.add.success",
  "Failed to add firmware.": "label.setting.firmware.notify.add.fail",
  "Only .pkg files are allowed.": "label.setting.firmware.notify.add.file.format",
  "Firmware updated successfully.": "label.setting.firmware.notify.update.success",
  "Failed to update firmware.": "label.setting.firmware.notify.update.fail",
  "Firmware deleted successfully.": "label.setting.firmware.notify.delete.success",
  "Failed to delete firmware.": "label.setting.firmware.notify.delete.fail",
  "Failed to get firmware download URL.": "label.setting.firmware.notify.download.fail",
  "Failed to get firmware update info.": "label.setting.firmware.notify.getInfo.fail",
  "Firmware upgrade updated successfully.": "label.setting.firmware.update.success",
  "Failed to update firmware upgrade.": "label.setting.firmware.update.fail",
  "Authentication failed due to a device issue.": "label.setting.firmware.upgradeError.1001",
  "Authentication failed due to a temporary account issue.": "label.setting.firmware.upgradeError.1002",
  "Preparation failed due to a firmware API issue.": "label.setting.firmware.upgradeError.2001",
  "Preparation failed due to a firmware API error. Additional error details may be available.": "label.setting.firmware.upgradeError.2002",
  "Upload failed due to multiple possible causes.": "label.setting.firmware.upgradeError.3001",
  "Preparation failed due to an issue with the provided firmware file.": "label.setting.firmware.upgradeError.3003",
  "An unknown error occurred. Please try again.": "label.setting.firmware.upgradeError.536870914",
  "The network connection to the node was lost. Please check your connection and try again.": "label.setting.firmware.upgradeError.536870931",
  "The operation failed. Please try again.": "label.setting.firmware.upgradeError.536870934",
  "The node is offline. Please check the device status and try again.": "label.setting.firmware.upgradeError.536870935",
  "Invalid node. Please verify the selected device and try again.": "label.setting.firmware.upgradeError.536870938",
  "The requested task does not exist.": "label.setting.firmware.upgradeError.536870941",
  "No recording data is available.": "label.setting.firmware.upgradeError.536870942",
  "Invalid parameters provided. Please check your input and try again.": "label.setting.firmware.upgradeError.536870943",
  "Device currently does not allow upgrade, please try again later.": "label.setting.firmware.upgradeError.536870944",
  "The device is busy and cannot process the request. Please try again later.": "label.setting.firmware.upgradeError.536870945",
  "User does not exist. Please check the account information.": "label.setting.firmware.upgradeError.536870947",
  "Incorrect password. Please try again.": "label.setting.firmware.upgradeError.536870948",
  "You do not have permission to perform this action.": "label.setting.firmware.upgradeError.536870953",
  "The system is busy and cannot process the request. Please try again later.": "label.setting.firmware.upgradeError.536870960",
  "The file stream has ended due to network issues or file completion.": "label.setting.firmware.upgradeError.536870961",
  "Failed to open audio. Please check the device or audio settings.": "label.setting.firmware.upgradeError.536870965",
  "Invalid file type. Please upload a supported file format.": "label.setting.firmware.upgradeError.536870977",
  "The file already exists.": "label.setting.firmware.upgradeError.536870978",
  "The file does not exist.": "label.setting.firmware.upgradeError.536870979",
  "Failed to create or open the file.": "label.setting.firmware.upgradeError.536870980",
  "Device resource limit reached. Please free up resources and try again.": "label.setting.firmware.upgradeError.536870982",
  "The maximum allowed quantity has been exceeded.": "label.setting.firmware.upgradeError.536871004",
  "Session verification failed. Please log in again.": "label.setting.firmware.upgradeError.536871011",
  "The device is already running the same version. Update is not required.": "label.setting.firmware.upgradeError.536871024",
  "No disk detected. Please check the storage device.": "label.setting.firmware.upgradeError.536871030",
  "Hash verification failed. The file may be corrupted.": "label.setting.firmware.upgradeError.536871055",
  "Data verification failed. Please try again.": "label.setting.firmware.upgradeError.536871056",
  "Failed to write the file.": "label.setting.firmware.upgradeError.536871057",
  "Failed to read the file.": "label.setting.firmware.upgradeError.536871058",
  "The specified channel does not exist.": "label.setting.firmware.upgradeError.536871059",
  "The task already exists.": "label.setting.firmware.upgradeError.536871060",
  "Firmware package not found.": "label.setting.firmware.errorCode.40001",
  "Firmware file not uploaded yet.": "label.setting.firmware.errorCode.40003",
  "File size or checksum mismatch.": "label.setting.firmware.errorCode.40004",
  "No fields to update.": "label.setting.firmware.errorCode.40005",
  "Firmware file is not ready to download.": "label.setting.firmware.errorCode.40006",
  "Firmware package already deleted.": "label.setting.firmware.errorCode.40007",
  "Failed to verify firmware upload.": "label.setting.firmware.errorCode.50021",
  "Failed to update firmware package.": "label.setting.firmware.errorCode.50022",
  "Failed to generate new upload URL.": "label.setting.firmware.errorCode.50023",
  "Failed to generate download URL.": "label.setting.firmware.errorCode.50024",
  "Failed to delete firmware package.": "label.setting.firmware.errorCode.50025",
  "Recorder communication failure.": "label.setting.firmware.errorCode.90006",
  "Firmware upgrade not supported.": "label.setting.firmware.errorCode.90013",
  "Email history deleted successfully.": "label.setting.email.notify.delete.success",
  "Failed to delete email history.": "label.setting.email.notify.delete.fail",
  "Scheduled email deleted successfully.": "label.setting.email.notify.schedule.delete.success",
  "Failed to delete scheduled email.": "label.setting.email.notify.schedule.delete.fail",
  "Failed to update notice display.": "label.setting.notice.notify.display.update.fail",
  "Notice added successfully.": "label.setting.notice.notify.add.success",
  "Failed to add notice.": "label.setting.notice.notify.add.fail",
  "Notice updated successfully.": "label.setting.notice.notify.update.success",
  "Failed to update notice.": "label.setting.notice.notify.update.fail",
  "Notice deleted successfully.": "label.setting.notice.notify.delete.success",
  "Failed to delete notice.": "label.setting.notice.notify.delete.fail",
  "Recorder location updated successfully.": "label.dash.notify.missing.update.success",
  "Failed to update recorder location. The address is incorrect.": "label.dash.notify.missing.update.fail.address",
  "Failed to update layout.": "label.dash.widget.update.fail",
  "Submission completed successfully.": "label.about.notify.tech.send.success",
  "Failed to submit.": "label.about.notify.tech.send.fail",
  "Failed to get contact info": "label.contact.get.fail",
  "Passkey login failed. Please enter your password.": "label.passkey.loginFailed",
  "Passkey setup failed. Please try again.": "label.passkey.setupFailed",
  "Passkey setup successful. Please login with your email and password.": "label.passkey.passkeySetupSuccess",
  "Manage Alert Rules": "user.permission.manageAlertRules",
  "View Alerts": "user.permission.viewAlerts",
  "Manage Users and Groups": "user.permission.manageUsersAndGroups",
  "View Users and Groups": "user.permission.viewUsersAndGroups",
  "Manage Report Rules": "user.permission.manageReportRules",
  "View Reports": "user.permission.viewReports",
  "Manage Recorders and Groups": "user.permission.manageRecordersAndGroups",
  "View Recorders and Groups": "user.permission.viewRecordersAndGroups",
  "Manage Organization": "user.permission.manageAccount",
  "View Organization": "user.permission.viewAccount",
  "View": "user.permission.videoShare",
  "Manage Subscription": "user.permission.manageSubscription",
  "View Subscription": "user.permission.viewSubscription",
  "myDW Guide Settings": "user.permission.videoGuideSetting",
  "Announcement": "user.permission.announcement",
  "Tech Support": "user.permission.techSupport",
  "Site Notice": "user.permission.siteNotice",
  "Emails": "user.permission.emails",
  "My Organization": "user.permission.myOrganization",
  "Logging": "user.permission.logging",
  "Release Notes": "user.permission.releaseNotes",
  "Manage Device Maintenance": "user.permission.manageMaintenance",
  "Confirm the alert has been resolved?": "alert.popup.label.confirm.message",
  "Don't ask again in this alert view": "alert.popup.label.confirm.check",
  "Media aborted": "screenRecordingError.media_aborted.title",
  "The screen is down.": "screenRecordingError.media_aborted.description",
  "No specified media found": "screenRecordingError.no_specified_media_found.title",
  "The selected screen could not be found.": "screenRecordingError.no_specified_media_found.description",
  "Media in use": "screenRecordingError.media_in_use.title",
  "The screen or mic is being used elsewhere": "screenRecordingError.media_in_use.description",
  "Invalid media constraints": "screenRecordingError.invalid_media_constraints.title",
  "The selected screen or mic could not be found.": "screenRecordingError.invalid_media_constraints.description",
  "No constraints": "screenRecordingError.no_constraints.title",
  "The screen is not specified.'": "screenRecordingError.no_constraints.description",
  "Recorder error": "screenRecordingError.recorder_error.title",
  "An error occurred while recording the screen.": "screenRecordingError.recorder_error.description",
  "Screen recording has been canceled": "screenRecordingError.permission_denied.title",
  "Please allow screen or microphone permission.\nClick the left side of the address bar. Then, change the settings.": "screenRecordingError.permission_denied.description.chrome",
  "Please allow screen or microphone permission.\nClick the left side of the address bar and change the settings.": "screenRecordingError.permission_denied.description.edge",
  "Please allow screen or microphone permission.\nClick the left side of the address bar. And change the settings.": "screenRecordingError.permission_denied.description.firefox",
  "Please allow screen or microphone permission.\nPreferences -> Websites -> Microphone -> change to ‘Ask’\nPreferences -> Websites -> Screen Sharing -> change to ‘Ask’": "screenRecordingError.permission_denied.description.safari",
  "Rate limit exceeded.": "PasskeyErrorCode.30004",
  "The browser does not support WebAuthn.": "PasskeyErrorCode.110001",
  "Credential creation failed": "PasskeyErrorCode.110002",
  "Credential verification failed": "PasskeyErrorCode.110003",
  "Please try logging in via email or set up your passkey again.": "PasskeyErrorCode.110004",
  "Passkey registration failed.": "PasskeyErrorCode.110005",
  "Passkey registration successful.": "PasskeyErrorCode.110006",
  "Passkey removal successful.": "PasskeyErrorCode.110007",
  "Passkey removal failed.": "PasskeyErrorCode.110008",
  "This email is already registered": "ServerErrorCode.1000",
  "This email is not registered.": "ServerErrorCode.1001",
  "The password you entered is incorrect.": "ServerErrorCode.1002",
  "The user has not accepted the invitation": "ServerErrorCode.1003",
  "Authentication failed.": "ServerErrorCode.1004",
  "User group not found.": "ServerErrorCode.1005",
  "Phone number has not been verified.": "ServerErrorCode.1006",
  "Phone number not found.": "ServerErrorCode.1007",
  "If you are the only administrator, you can't deactivate. Invite or reassign a new user to be an administrator and try again.": "ServerErrorCode.1008",
  "The default user group cannot be deleted.": "ServerErrorCode.1009",
  "The token is not found.": "ServerErrorCode.1010",
  "The token has expired.": "ServerErrorCode.1011",
  "User must belong to at least one group.": "ServerErrorCode.1012",
  "If you are the only administrator, you cannot deactivate. Invite or reassign a new user to be an administrator and try again.": "ServerErrorCode.1013",
  "You don't have permission to delete users.": "ServerErrorCode.1014",
  "DW Spectrum cloud email does not match the invited email.": "ServerErrorCode.1015",
  "The user group name already exists.": "ServerErrorCode.1019",
  "The update failed because there are no administrators in the organization. At least one user must be in the Administrator Group.": "ServerErrorCode.1020",
  "Unable to send SMS for 2FA.": "ServerErrorCode.1021",
  "Unable to send Email for 2FA.": "ServerErrorCode.1022",
  "2FA verification failed.": "ServerErrorCode.1023",
  "2FA code has expired. Please resend code and try again.": "ServerErrorCode.1024",
  "The owner cannot be deleted.": "ServerErrorCode.1025",
  "The owner must belong to an administrator group.": "ServerErrorCode.1026",
  "You are not allowed to select apply all.": "ServerErrorCode.1027",
  "Free trial email sent again.": "ServerErrorCode.1029",
  "Verification failed. Please check your code.": "ServerErrorCode.1030",
  "Your login code has expired.": "ServerErrorCode.1031",
  "Invalid code. Please try again.": "ServerErrorCode.1032",
  "Failed to register passkey.": "ServerErrorCode.1033",
  "Passkey limit exceeded. You can only add up to 3 passkeys.": "ServerErrorCode.1034",
  "Organization not found": "ServerErrorCode.3001",
  "Cannot delete organization.": "ServerErrorCode.3002",
  "Organization and user not found": "ServerErrorCode.3003",
  "Invalid organization: Not allowed to register recorder.": "ServerErrorCode.3004",
  "Invalid organization: Not applicable for license information.": "ServerErrorCode.3005",
  "CP organization with EU/CP organization(s) cannot be deleted.": "ServerErrorCode.3006",
  "EU organization with recorder(s) cannot be deleted.": "ServerErrorCode.3007",
  "The organization name already exists.": "ServerErrorCode.3008",
  "No Channel Partner found for Free Trial.": "ServerErrorCode.3009",
  "Unable to send Free Trial email to the manager group.": "ServerErrorCode.3010",
  "Your company already registered.": "ServerErrorCode.3021",
  "Recorder not found": "ServerErrorCode.5001",
  "Recorder and recorder group are empty.": "ServerErrorCode.5002",
  "Recorder is already registered.": "ServerErrorCode.5003",
  "Recorder group not found.": "ServerErrorCode.5004",
  "Permission denied": "ServerErrorCode.5005",
  "Recorder is already registered with another organization.": "ServerErrorCode.5006",
  "System is already registered with another organization.": "ServerErrorCode.5007",
  "P2P ID does not exist.": "ServerErrorCode.5008",
  "Local spectrum information does not exist.": "ServerErrorCode.5009",
  "Username or Password is incorrect.": "ServerErrorCode.5010",
  "Local DW Spectrum connection failed.": "ServerErrorCode.5011",
  "Local DW Spectrum connection timed out.": "ServerErrorCode.5012",
  "DW Cloud connection failed.": "ServerErrorCode.5013",
  "The user information of the DW Cloud system is different.": "ServerErrorCode.5014",
  "System not found in DW Spectrum Cloud Account.": "ServerErrorCode.5015",
  "The recorder group name already exists.": "ServerErrorCode.5016",
  "The license value has changed. The license screen will be refreshed. Please try again.": "ServerErrorCode.6001",
  "The license value has changed. The license screen will be refreshed. Please wait a moment and try again.": "ServerErrorCode.6002",
  "Storage amount must be an integer.": "ServerErrorCode.6003",
  "No subscription request found.": "ServerErrorCode.6004",
  "Camera not found.": "ServerErrorCode.7001",
  "Camera is already registered.": "ServerErrorCode.7002",
  "Alert rule not found.": "ServerErrorCode.8001",
  "System alert rule cannot be deleted.": "ServerErrorCode.8002",
  "Performance alert rule cannot be deleted.": "ServerErrorCode.8003",
  "Camera alert rule cannot be deleted.": "ServerErrorCode.8004",
  "The Alert rule name already exists.": "ServerErrorCode.8005",
  "Alert history not found.": "ServerErrorCode.9001",
  "Already registered.": "ServerErrorCode.10001",
  "Video Share not found.": "ServerErrorCode.11001",
  "Video Share User not found.": "ServerErrorCode.11002",
  "Video sharing has expired.": "ServerErrorCode.11003",
  "Failed to register video share.": "ServerErrorCode.11004",
  "Failed to obtain signed URL.": "ServerErrorCode.11005",
  "Video share has been cancelled.": "ServerErrorCode.11006",
  "Report not found.": "ServerErrorCode.12001",
  "It's not a CVV report.": "ServerErrorCode.12002",
  "The report name already exists.": "ServerErrorCode.12003",
  "Subscription Key is not found.": "ServerErrorCode.12107",
  "Subscription Key is already registered.": "ServerErrorCode.12109",
  "AWS communication failed.": "ServerErrorCode.20001",
  "DW Spectrum cloud users cannot change the email or password.": "ServerErrorCode.30001",
  "Authentication information does not exist. Please contact your administrator.": "ServerErrorCode.30008",
  "Authentication denied. Try again in a minute": "ServerErrorCode.31000",
  "User Permission not found.": "ServerErrorCode.40001",
  "This feature is available to DW organization only.": "ServerErrorCode.40002",
  "Notice schedule is not registered.": "ServerErrorCode.50001",
  "Email schedule is not scheduled.": "ServerErrorCode.50002",
  "Scheduled Email Not Found.": "ServerErrorCode.50003",
  "Email Not Found.": "ServerErrorCode.50004",
  "Scheduled email job not found.": "ServerErrorCode.50005",
  "Failed to generate firmware upload URL.": "ServerErrorCode.50014",
  "An active firmware package for this device version and model already exists.": "ServerErrorCode.50016",
  "Redis related task failed.": "ServerErrorCode.60001",
  "Cloud Storage not found.": "ServerErrorCode.70001",
  "Cloud Storage is full.": "ServerErrorCode.70002",
  "Installation Report not found.": "ServerErrorCode.80001",
  "Installation report of the cameras not found": "ServerErrorCode.80002",
  "Installation Report updated successfully.": "ServerErrorCode.80003",
  "Failed to update installation report.": "ServerErrorCode.80004",
  "Failed to delete the report.": "ServerErrorCode.80005",
  "Thumbnail not found.": "ServerErrorCode.90003",
  "Thumbnail not found": "ServerErrorCode.90004",
  "Thumbnail does not exist.": "ServerErrorCode.90005",
  "Camera is invalid.": "ServerErrorCode.90007",
  "Camera is offline.": "ServerErrorCode.90008",
  "Camera is unauthorized.": "ServerErrorCode.90009",
  "Camera is not recording.": "ServerErrorCode.90010",
  "Recorder is not responding.": "ServerErrorCode.90011",
  "Recorder's auth fail.": "ServerErrorCode.90012",
  "Failed file operation.": "ServerErrorCode.100000",
  "Feature not supported on this system.": "ServerErrorCode.100001",
  "Request to messenger failed": "ServerErrorCode.100003",
  "Recorder authentication error.": "ServerErrorCode.100004",
  "Recorder not responding": "ServerErrorCode.100005",
  "Missing parameter(s) or invalid parameter values.": "ServerErrorCode.100006",
  "Report has already been created.": "ServerErrorCode.100007",
  "Agent failed to response.": "ServerErrorCode.100008",
  "Cannot assign permissions that exceed the current authority of the group's creator.": "ServerErrorCode.100009",
  "Request to DW Spectrum failed.": "ServerErrorCode.110000",
  "File size exceeded the limit.": "ServerErrorCode.110001",
  "Retry limit has been exceeded.": "ServerErrorCode.111000",
  "Service is duplicated.": "ServerErrorCode.120001",
  "Price tier is duplicated.": "ServerErrorCode.120002",
  "Subscription not found.": "ServerErrorCode.121000",
  "Key generation failed.": "ServerErrorCode.121003",
  "There is no price information from the organization.": "ServerErrorCode.121004",
  "There was an issue processing the payment.": "ServerErrorCode.121005",
  "The process was halted due to an undefined key type.": "ServerErrorCode.121006",
  "Subscription key is not found.": "ServerErrorCode.121007",
  "Subscription key is not registered.": "ServerErrorCode.121008",
  "Subscription key is already registered.": "ServerErrorCode.121009",
  "Subscription type is undefined.": "ServerErrorCode.121010",
  "Subscription type is already activated.": "ServerErrorCode.121011",
  "Only EU organizations are searchable": "ServerErrorCode.121012",
  "Only CP organizations are searchable": "ServerErrorCode.121013",
  "Failed to send email.": "ServerErrorCode.121014",
  "Failed to update price using Stripe API.": "ServerErrorCode.121015",
  "Service price not found.": "ServerErrorCode.121016",
  "Failed to update price.": "ServerErrorCode.121017",
  "The registered key is not associated with the parent CP.": "ServerErrorCode.121018",
  "Unable to retrieve CP information.": "ServerErrorCode.121019",
  "Export failed while creating the file.": "ServerErrorCode.121020",
  "Failed to confirm subscription request. ": "ServerErrorCode.121021"
} as const;
export default reverse;
